export enum MemberStates {
  SUBSCRIBED = 'subscribed',
  INVITED = 'invited',
  PENDING = 'pending',
  APPROVED = 'approved',
  BLOCKED = 'blocked',
}
